export default __webpack_public_path__ + "static/media/intrus.89e1c607.svg";